import { DataTableColumnDef } from "@/components/molecules";
import { renderColumnHeaderWithTooltip } from "../helpers";
import { VehicleCategoryColumnHeader } from "../common/VehicleCategoryColumnHeader";
import { AffiliateVehicleTableData } from "./types";

export const affiliateVehiclesColumns: DataTableColumnDef<AffiliateVehicleTableData>[] = [
  {
    header: "Year",
    size: 100,
    accessorKey: "year",
    sortDescFirst: false,
  },
  {
    header: "Make",
    accessorKey: "make",
    cell: (props) => props.row.original.make,
    size: 150,
    sortDescFirst: false,
  },
  {
    header: "Model",
    accessorKey: "model",
    size: 150,
    sortDescFirst: false,
  },
  {
    header: "Number Plate",
    accessorKey: "registration_number",
    cell: (props) => props.row.original.numberPlate,
    size: 150,
    sortDescFirst: false,
  },
  {
    header: "Color",
    id: "color",
    cell: (props) => props.row.original.color,
    size: 150,
  },
  {
    header: renderColumnHeaderWithTooltip("Vehicle Type", "Operator-defined vehicle type used within your own fleet setup", "For internal bookings"),
    id: "vehicleType",
    cell: (props) => props.row.original.vehicleType,
    size: 150,
  },
  {
    header: VehicleCategoryColumnHeader,
    id: "vehicleCategory",
    accessorKey: "vehicleCategory",
    size: 175,
    // Backend vehicle search only sorts on make/model/registration_number/year/identifier.
    enableSorting: false,
  },
  {
    header: "State",
    id: "state",
    cell: (props) => props.row.original.state,
    size: 150,
  },
  {
    header: "Owner",
    id: "driver",
    cell: (props) => props.row.original.owner,
    size: 200,
  },
  {
    header: "Status",
    id: "status",
    cell: (props) => props.row.original.status,
    size: 150,
  },
  {
    header: "Actions",
    id: "actions",
    cell: (props) => props.row.original.actions,
    maxSize: 75,
  },
];
